import {
    BaseEnvironment,
    type KeycloakContext,
} from "@keycloak/keycloak-ui-shared";

import { parseResponse } from "./parse-response.ts";
import {
    CredentialContainer,
    Group,
} from "@keycloak/keycloak-account-ui";
import { request } from "./request";
import { Credential } from "./representations.ts";

export type CallOptions = {
    context: KeycloakContext<BaseEnvironment>;
    signal?: AbortSignal;
};

export type PaginationParams = {
    first: number;
    max: number;
};

export interface ExtendedGroup extends Group {
    attributes?: Record<string, string[]>; // Attributes as key-value pairs
}

function isPasswordlessCredentialContainer(container: CredentialContainer) {
    return [
        container.type,
        container.displayName,
        container.helptext,
        container.createAction,
        container.updateAction,
    ]
        .filter((value): value is string => typeof value === "string")
        .some((value) => value.toLowerCase().includes("passwordless"));
}

export async function getGroupsExtended({ signal, context }: CallOptions): Promise<ExtendedGroup[]> {
    const response = await request("/groups?briefRepresentation=false", context, {
        signal,
    });
    return parseResponse<ExtendedGroup[]>(response);
}

export async function getCredentialsContainers({ signal, context }: CallOptions): Promise<CredentialContainer[]> {
    const response = await request("/credentials/containers", context, {
        signal,
    }, "mphise-account");
    const parsedResponse = parseResponse<CredentialContainer[]>(response);
    return (await parsedResponse).filter((container) => !isPasswordlessCredentialContainer(container));

}

export async function getOrderedCredentials({ signal, context }: CallOptions): Promise<Credential[]> {
    const response = await request("/credentials", context, {
        signal,
    }, "mphise-account");
    return parseResponse<Credential[]>(response);
}

export async function setDefaultMfaMethod(credContainerType: string, { signal, context }: CallOptions) {
    const response = await request(`/credentials/${credContainerType}/moveToFirst`, context, {
        signal,
        method: "POST",
    }, "mphise-account");
    return response.ok;
}

// private setDefaultMfaMethod(credContainerType: string, credContainerType: string): void {
//     console.log("Setting default MFA method: " + JSON.stringify(credContainerType));

//     //const reqData: UserAttributes = { attributes: { defaultMfa:[credContainerType]}};
//     this.context!.doMyHomelandPost<void>("/credentials/"+credContainerType+"/moveToFirst", {})
//         .then(() => {
//             ContentAlert.success('defaultMfaUpdated');
//             window.location.reload();
//         });
// }
